import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  message: string = 'Snack Bar opened.';
  actionButtonLabel: string = 'Retry';
  action: boolean = true;
  setAutoHide: boolean = true;
  autoHide: number = 2000;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  notification: BehaviorSubject<any> = new BehaviorSubject(null);

  constructor(private _snackBar: MatSnackBar,
    private translate: TranslateService,

  ) {
  }

  success(message: string, dismissible: string, autoDismiss: number, popup?, title?, details?, severity?, appendToId?) {
    // autoDismiss = 8000;
    this.translate.get([message]).subscribe(res => {

      try {
        document.getElementById('tm-popup-notification-window').innerHTML = message;
      }
      catch (err) {
      }

      let notification_obj = {
        title: title || '',
        summary: res[message] || message,
        details: details || '',
        severity: 'success',
        dismissible: dismissible,
        autoDismiss: autoDismiss,
        appendToId: appendToId || 'pageMessages',
        success: 1,
        popup: popup
      }
      // if (appendToId) {
      //   appendToId.innerHTML = res['summary'];
      // }
      // setTimeout(() => {
      //   appendToId.innerHTML = '';
      // }, autoDismiss);
      this.notification.next(notification_obj)
    })
    // let config = new MatSnackBarConfig();
    // config.verticalPosition = this.verticalPosition;
    // config.horizontalPosition = this.horizontalPosition;

    // config.duration = autoDismiss || this.autoHide;
    // config.panelClass = 'success-snackbar';
    // config.data = translations[message] || message
    // this._snackBar.openFromComponent(JsrSnackbarComponent, config)



  }
  error(message: string, dismissible: string, autoDismiss: number, title?, details?, severity?, appendToId?) {
    // let notification_obj = {
    //   title: title || '',
    //   summary: message,
    //   details: details || '',
    //   severity: 'danger',
    //   dismissible: dismissible,
    //   autoDismiss: autoDismiss,
    //   appendToId: appendToId || 'pageMessages',
    //   success: 0
    // }
    // console.log(notification_obj)
    // this.notification.next(notification_obj)
    this.translate.get([message]).subscribe(res => {

      let notification_obj = {
        title: title || '',
        summary: res[message] || message,
        details: details || '',
        severity: 'danger',
        dismissible: dismissible,
        autoDismiss: autoDismiss,
        appendToId: appendToId || 'pageMessages',
        success: 0
      }

      //   if (appendToId) {
      //     appendToId.innerHTML = res['summary'];
      //     appendToId.style.color = 'var(--js-red)';
      //   }
      this.notification.next(notification_obj)
    })
    // autoDismiss = 8000;
    // let config = new MatSnackBarConfig();
    // config.verticalPosition = this.verticalPosition;
    // config.horizontalPosition = this.horizontalPosition;
    // config.duration = autoDismiss || this.autoHide;
    // config.panelClass = 'error-snackbar';
    // config.data = translations[message] || message;
    // this._snackBar.openFromComponent(JsrSnackbarComponent, config)


  }

  snackbar(title, action, duration) {
    this._snackBar.open(title, action, {
      duration: duration
    });
  }
}
